import haviPortfolioElemzesekTemplate from './havi-portfolio-elemzesek.pug';

const MODULE_NAME = 'haviPortfolioElemzesek';
class HaviPortfolioElemzesekController {
	constructor() {
		'ngInject';
	}

	$onInit() {
		this.haviPortfolioElemzesekTitle = window.haviPortfolioElemzesekTitle;
		this.haviPortfolioElemzesekLabel = window.haviPortfolioElemzesekLabel;
		this.haviPortfolioElemzesek = window.haviPortfolioElemzesek;
		this.selectedYear = this.haviPortfolioElemzesek[0];
	}
}

export default angular.module(MODULE_NAME, [])
	.component(MODULE_NAME, {
		controller: HaviPortfolioElemzesekController,
		template: haviPortfolioElemzesekTemplate(),
		bindings: {
		}
	}).name;




// WEBPACK FOOTER //
// ../source/application/havi-portfolio-elemzesek/havi-portfolio-elemzesek.js